import { render, staticRenderFns } from "./GoodSearch.vue?vue&type=template&id=b427be7e&scoped=true"
import script from "./GoodSearch.vue?vue&type=script&lang=js"
export * from "./GoodSearch.vue?vue&type=script&lang=js"
import style0 from "./GoodSearch.vue?vue&type=style&index=0&id=b427be7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b427be7e",
  null
  
)

export default component.exports